export const pairModalType = "pair";
